import { DeviceType } from "@tether-web-portal/types/DeviceType";
import { PropertyType } from "./PropertyType";

export enum PIDeviceTypes {
  enviroq = "enviroq",
  thermalq = "thermalq",
  hotdrop = "hotdrop",
  airwits = "airwits",
  airwits_iaq = "airwits_iaq",
  airwits_co2 = "airwits_co2",
  airwits_co2_plus = "airwits_co2_plus",
  airwits_pm = "airwits_pm",
  detectify = "detectify",
  flexsense = "flexsense",
  flexsense_probe = "flexsense_probe",
  gateway = "gateway",
  room_radar = "room_radar",
  voltdrop = "voltdrop",
  adeunis_pulse = "adeunis_pulse",
  adeunis_pulse_water = "adeunis_pulse_water",
  ems2desk = "ems2desk",
  ers2eye = "ers2eye",
  solar_csv = "solar_csv",
  victron_energy_inverter = "victron_energy_inverter",
  milesight_am102 = "milesight_am102",
  milesight_am103 = "milesight_am103",
  milesight_am308 = "milesight_am308",
  milesight_am319 = "milesight_am319",
  milesight_em300 = "milesight_em300",
  milesight_em320 = "milesight_em320",
  milesight_ws202 = "milesight_ws202",
  milesight_ws203 = "milesight_ws203",
  milesight_ws523 = "milesight_ws523",
  milesight_vs34x = "milesight_vs34x",
  milesight_vs330 = "milesight_vs330",
  milesight_vs351 = "milesight_vs351",
  milesight_vs360 = "milesight_vs360",
  milesight_vs121 = "milesight_vs121",
  milesight_vs321 = "milesight_vs321",
  moko_lw005 = "moko_lw005",
  pcs_flowmeter = "pcs_flowmeter",
  krohne_afe400_flowmeter = "krohne_afe400_flowmeter",
  pflow_e3r_flowmeter = "pflow_e3r_flowmeter",
  milesight_ct = "milesight_ct",
  milesight_ct_three_phase = "milesight_ct_three_phase",
  milesight_cth01 = "milesight_cth01",
  milesight_cth01_circuit = "milesight_cth01_circuit",
  milesight_cth01_three_phase_circuit = "milesight_cth01_three_phase_circuit",
  quandify_cubicmeter = "quandify_cubicmeter",
  bove_beco = "bove_beco",
  genus_intellilog = "genus_intellilog",
  elsys_ers_lite = "elsys_ers_lite",
  elsys_ers_co2 = "elsys_ers_co2",
  elsys_ers_co2_lite = "elsys_ers_co2_lite",
  elsys_ers_voc = "elsys_ers_voc",
  elsys_ers_eye = "elsys_ers_eye",
  elsys_ers_sound = "elsys_ers_sound",
}

export const PIDeviceToDeviceType: Record<PIDeviceTypes, DeviceType> = {
  [PIDeviceTypes.enviroq]: DeviceType.ENVIROQ,
  [PIDeviceTypes.thermalq]: DeviceType.THERMALQ,
  [PIDeviceTypes.hotdrop]: DeviceType.HOTDROP,
  [PIDeviceTypes.moko_lw005]: DeviceType.MOKO_LW005,
  [PIDeviceTypes.voltdrop]: DeviceType.VOLTDROP,
  [PIDeviceTypes.airwits]: DeviceType.AIRWITS,
  [PIDeviceTypes.airwits_iaq]: DeviceType.AIRWITS_IAQ,
  [PIDeviceTypes.airwits_co2]: DeviceType.AIRWITS_CO2,
  [PIDeviceTypes.airwits_co2_plus]: DeviceType.AIRWITS_CO2_PLUS,
  [PIDeviceTypes.airwits_pm]: DeviceType.AIRWITS_PM,
  [PIDeviceTypes.detectify]: DeviceType.DETECTIFY,
  [PIDeviceTypes.flexsense]: DeviceType.FLEXSENSE,
  [PIDeviceTypes.flexsense_probe]: DeviceType.FLEXSENSE_PROBE,
  [PIDeviceTypes.gateway]: DeviceType.GATEWAY,
  [PIDeviceTypes.room_radar]: DeviceType.ROOM_RADAR,
  [PIDeviceTypes.adeunis_pulse_water]: DeviceType.ADEUNIS_PULSE_WATER,
  [PIDeviceTypes.adeunis_pulse]: DeviceType.ADEUNIS_PULSE,
  [PIDeviceTypes.ems2desk]: DeviceType.EMS2DESK,
  [PIDeviceTypes.ers2eye]: DeviceType.ERS2EYE,
  [PIDeviceTypes.milesight_em300]: DeviceType.MILESIGHT_EM300,
  [PIDeviceTypes.milesight_em320]: DeviceType.MILESIGHT_EM320,
  [PIDeviceTypes.milesight_am102]: DeviceType.MILESIGHT_AM102,
  [PIDeviceTypes.milesight_am103]: DeviceType.MILESIGHT_AM103,
  [PIDeviceTypes.milesight_ws202]: DeviceType.MILESIGHT_WS202,
  [PIDeviceTypes.milesight_ws203]: DeviceType.MILESIGHT_WS203,
  [PIDeviceTypes.milesight_vs34x]: DeviceType.MILESIGHT_VS34X,
  [PIDeviceTypes.milesight_vs330]: DeviceType.MILESIGHT_VS330,
  [PIDeviceTypes.milesight_vs351]: DeviceType.MILESIGHT_VS351,
  [PIDeviceTypes.milesight_vs360]: DeviceType.MILESIGHT_VS360,
  [PIDeviceTypes.milesight_vs121]: DeviceType.MILESIGHT_VS121,
  [PIDeviceTypes.solar_csv]: DeviceType.SOLAR_CSV,
  [PIDeviceTypes.victron_energy_inverter]: DeviceType.VICTRON_ENERGY_INVERTER,
  [PIDeviceTypes.pcs_flowmeter]: DeviceType.PCS_FLOWMETER,
  [PIDeviceTypes.milesight_ct]: DeviceType.MILESIGHT_CT,
  [PIDeviceTypes.milesight_ct_three_phase]: DeviceType.MILESIGHT_CT_THREE_PHASE,
  [PIDeviceTypes.milesight_cth01]: DeviceType.MILESIGHT_CTH01,
  [PIDeviceTypes.milesight_cth01_circuit]: DeviceType.MILESIGHT_CTH01_CIRCUIT,
  [PIDeviceTypes.milesight_cth01_three_phase_circuit]: DeviceType.MILESIGHT_CTH01_THREE_PHASE_CIRCUIT,
  [PIDeviceTypes.quandify_cubicmeter]: DeviceType.QUANDIFY_CUBICMETER,
  [PIDeviceTypes.bove_beco]: DeviceType.BOVE_BECO,
  [PIDeviceTypes.genus_intellilog]: DeviceType.GENUS_INTELLILOG,
  [PIDeviceTypes.milesight_am308]: DeviceType.MILESIGHT_AM308,
  [PIDeviceTypes.milesight_am319]: DeviceType.MILESIGHT_AM319,
  [PIDeviceTypes.milesight_ws523]: DeviceType.MILESIGHT_WS523,
  [PIDeviceTypes.milesight_vs321]: DeviceType.MILESIGHT_VS321,
  [PIDeviceTypes.krohne_afe400_flowmeter]: DeviceType.KROHNE_AFE400_FLOWMETER,
  [PIDeviceTypes.pflow_e3r_flowmeter]: DeviceType.PFLOW_E3R_FLOWMETER,
  [PIDeviceTypes.elsys_ers_lite]: DeviceType.ELSYS_ERS_LITE,
  [PIDeviceTypes.elsys_ers_co2]: DeviceType.ELSYS_ERS_CO2,
  [PIDeviceTypes.elsys_ers_co2_lite]: DeviceType.ELSYS_ERS_CO2_LITE,
  [PIDeviceTypes.elsys_ers_voc]: DeviceType.ELSYS_ERS_VOC,
  [PIDeviceTypes.elsys_ers_eye]: DeviceType.ELSYS_ERS_EYE,
  [PIDeviceTypes.elsys_ers_sound]: DeviceType.ELSYS_ERS_SOUND,
};

export interface PropertyInfo {
  id: string;
  organisationId: string;
  type: PropertyType;
  address1: string;
  address2: string;
  addressCity: string;
  addressCountry: string;
  addressPostcode: string;
  customPropertyId: string;
  latitude: number;
  longitude: number;
  palaceId?: string;
  propertyTags: string[];
  tetherTickCompleted: boolean;
}

export interface PropertyInfoWithDeviceCounts extends PropertyInfo {
  deviceCounts: Record<PIDeviceTypes, number>;
}

export interface PropertyInfoWithDeviceCountsFlattened extends PropertyInfoWithDeviceCounts {
  totalDeviceCount: number;
}
